import { Campaign } from '@markant-platform/campaign/model';

export enum RegistrationStep {
  INTRO = 'INTRO',
  ORGANIZATION = 'ORGANIZATION',
  BILLING = 'BILLING',
  USER = 'USER',
  OUTRO = 'OUTRO',
}

export type CampaignRegistrationState = {
  isLoading: boolean;
  isProcessing: boolean;
  campaign: Campaign | null;
  termsOfUseLink: string;
  privacyPolicyLink: string;
  serviceConditionsLink: string;
  serviceGTCLink: string;
  isRegistrationSuccess: boolean;
};
